import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Component({
  selector: "app-kpi-commission-earnings-rentals",
  templateUrl: "./kpi-commission-earnings-rentals.component.html",
  styleUrls: ["./kpi-commission-earnings-rentals.component.scss"],
})
export class KpiCommissionEarningsRentalsComponent {
  @Input() resources$: Observable<any>;

  constructor(private router: Router) {}

  navigateToObject(eaOid: string, event: Event): void {
    event.preventDefault();
    this.router.navigate([
      "/crm",
      {
        outlets: {
          primary: ["showings", eaOid],
          sidebar: null,
          modal: [],
        },
      },
    ]);
  }
}
